import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../state/auth/useAuth';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return null; // Could render a spinner
  if (!isAuthenticated) {
    // Redirect to signin page instead of landing page for better UX
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }
  return children;
}
